/**
 * Loads a standardized LA City header which is shared by many websites,
 * such as LACERS.
 */

const defaults = {
  id: 'global_navbar_la_4324422',
};

export default class LACityHeader {
  constructor(destination, options) {
    this.destination = destination;
    this.settings = { ...defaults, ...options };

    const header = document.getElementById(this.settings.id);
    if (header && this.destination) {
      this.destination.prepend(header);
    }
  }
}
